//MARK: Done
export const version = "v2";

export const getApiPath = (path: "version") => {
  return `/${version}`;
};

export const versionApiPath = getApiPath("version");
